import get from 'lodash/get'
import { IntlProvider, MessageFormatElement } from 'react-intl'
import { WrapperProps } from '.'
import { DEFAULT_UI_LANGUAGE_VALUE } from '../constants'
import { useTranslationData } from '../contexts'
import { flattenMessages, TranslationsMap } from '../utils'

interface CustomTranslationsWrapperProps extends WrapperProps {
  data: TranslationsMap
}

export const CustomTranslationsWrapper = ({
  children,
  data
}: CustomTranslationsWrapperProps) => {
  const { UILanguage, localizedOptionsLists } = useTranslationData()

  const languageKey = UILanguage || DEFAULT_UI_LANGUAGE_VALUE

  const localizedMessages = get(data.translations, languageKey)

  const localizedLinks = data.unionLinks
    ? {
        localizedLinkList: get(data.unionLinks, languageKey).map((link) => {
          const { linkStyleType, ...rest } = link
          return {
            ...rest,
            important: linkStyleType === 'important'
          }
        })
      }
    : undefined

  const localizedBusinessLanguageOptions = data.businessLanguages
    ? {
        localizedBusinessLanguageList: get(data.businessLanguages, languageKey)
      }
    : undefined

  const localizedPaymentOptions = data.paymentOptions
    ? {
        localizedPaymentOptionList: get(data.paymentOptions, languageKey)
      }
    : undefined

  const messages = flattenMessages(
    localizedMessages,
    localizedOptionsLists,
    localizedLinks,
    localizedBusinessLanguageOptions,
    localizedPaymentOptions
  ) as Record<string, MessageFormatElement[]>

  return (
    <IntlProvider locale={UILanguage} messages={messages}>
      {children}
    </IntlProvider>
  )
}
